import { ErrData, replaceErrors, httpReturnSafeError } from '@iotv/iotv-v3-types'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from './debug'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)

export { replaceErrors, httpReturnSafeError }

export type LambdaProxyResponse = {
  statusCode: StatusCodes
  headers: {
    'Access-Control-Allow-Credentials': true
    'Access-Control-Allow-Headers': '*'
    'Access-Control-Allow-Origin': '*'
  }
  body: string
  isBase64Encoded: boolean
}

export enum StatusCodes {
  INTERNAL_SERVER_ERROR = 500,
  OK = 200,
}

export enum HttpMethods {
  OPTIONS = 'OPTIONS',
  ANY = 'ANY',
  POST = 'POST',
  GET = 'GET',
}

export const getLambdaProxyResponse = <T>(responseBody: ErrData<T>, statusCode: StatusCodes): LambdaProxyResponse => {
  debug && console.log('response body in lambda response', responseBody)

  return {
    statusCode,
    headers: {
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify(responseBody, replaceErrors),
    isBase64Encoded: false,
  }
}

export const getLambdaProxyError = (context: any | undefined) => {
  return {
    errorType: 'InternalServerError',
    httpStatus: StatusCodes.INTERNAL_SERVER_ERROR,
    requestId: context?.awsRequestId,
    message: 'An unknown error has occurred. Please try again.',
  }
}
